module.exports = {"520201101":"大河镇","520201102":"汪家寨镇","520201103":"大湾镇","520201400":"建设路社区服务中心","520201401":"黄土坡社区服务中心","520201402":"红岩社区服务中心","520201403":"荷泉社区服务中心","520201404":"荷城社区服务中心","520201405":"杉树林社区服务中心","520201406":"杨柳社区服务中心","520201407":"场坝社区服务中心","520201408":"凤凰社区服务中心","520201409":"广场社区服务中心","520201410":"明湖社区服务中心","520201411":"德坞社区服务中心","520201412":"西宁社区服务中心","520201413":"月照社区服务中心","520201415":"双戛社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520201.json
// module id = 2457
// module chunks = 0